import React from 'react';
// Adicione o ícone 'Users' à importação
import { LayoutDashboard, Settings, Users } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

// Sub-componente interno para os links de navegação
const NavLink = ({ page, activePage, setActivePage, icon, children }) => (
    <li className="nav-item">
        <button 
            className={`nav-link w-100 text-start d-flex align-items-center ${activePage === page ? 'active' : ''}`}
            onClick={() => setActivePage(page)}
        >
            {icon}
            {children}
        </button>
    </li>
);

function Sidebar({ activePage, setActivePage, mspData }) {
    const { theme } = useTheme();

    const defaultLogoLight = '/logo_light.png';
    const defaultLogoDark = '/logo_dark.png';
    
    // Adiciona uma verificação para garantir que mspData não seja nulo
    const logoLight = mspData?.brandLogoLightURL || defaultLogoLight;
    const logoDark = mspData?.brandLogoDarkURL || defaultLogoDark;

    const logoSrc = theme === 'dark' ? logoDark : logoLight;

    return (
        <aside className="d-flex flex-column flex-shrink-0 p-3 bg-body-tertiary border-end" style={{ width: '280px' }}>
            <div className="text-center mb-2">
                <button onClick={() => setActivePage('dashboard')} className="d-inline-block link-body-emphasis text-decoration-none border-0 bg-transparent p-0">
                    <img src={logoSrc} alt="Logo da Marca" style={{ maxHeight: '80px', maxWidth: '200px' }} />
                </button>
            </div>
            <hr />
            <ul className="nav nav-pills flex-column mb-auto">
                <NavLink 
                    page="dashboard" 
                    activePage={activePage} 
                    setActivePage={setActivePage} 
                    icon={<LayoutDashboard className="me-2" size={20} />}
                >
                    Dashboard
                </NavLink>
                
                {/* --- INÍCIO DA LÓGICA DO ADMIN --- */}
                {/* O link "Usuários" só aparece se mspData.isAdmin for true */}
                {mspData?.isAdmin && (
                    <NavLink
                        page="users"
                        activePage={activePage}
                        setActivePage={setActivePage}
                        icon={<Users className="me-2" size={20} />}
                    >
                        Usuários
                    </NavLink>
                )}
                {/* --- FIM DA LÓGICA DO ADMIN --- */}

                <NavLink 
                    page="settings" 
                    activePage={activePage} 
                    setActivePage={setActivePage} 
                    icon={<Settings className="me-2" size={20} />}
                >
                    Configurações
                </NavLink>
            </ul>
            <hr />
        </aside>
    );
}

export default Sidebar;